import { render } from "./order-history.vue?vue&type=template&id=3eba519d&scoped=true"
import script from "./order-history.vue?vue&type=script&lang=js"
export * from "./order-history.vue?vue&type=script&lang=js"

import "./order-history.vue?vue&type=style&index=0&id=3eba519d&scoped=true&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eba519d"]])

export default __exports__